// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1FUMr","m-signature-pad--body":"styles__m-signature-pad--body____v7lu","m-signature-pad--footer":"styles__m-signature-pad--footer___1wECu","description":"styles__description___1QG_c","button":"styles__button___nyNgF","clear":"styles__clear___DOiY6","save":"styles__save___3bsVW","m-signature-pad":"styles__m-signature-pad___1_wtb","github":"styles__github___2Usnl","userDetailsPhoneType":"styles__userDetailsPhoneType___1frdN"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/users/UserDetailsBasicInfo/styles.scss
// module id = UaJO
// module chunks = client